import React from 'react';

export const TriangleUp = ({ isSelected }) => (
  <svg width="10" height="6" viewBox="0 0 10 6" xmlns="http://www.w3.org/2000/svg">
    <path
      style={{ fill: isSelected ? '#2D5BFF' : '#A1A1A1' }}
      d="M9.0654 5.07393L5.21696 0.611426C5.10681 0.483691 4.8947 0.483691 4.78337 0.611426L0.934934 5.07393C0.791965 5.24033 0.920871 5.48408 1.15173 5.48408H8.84861C9.07947 5.48408 9.20837 5.24033 9.0654 5.07393Z"
    />
  </svg>
);
